import { DocumentFilesReply } from '../dtos/DocumentFilesReply';
import { DocumentFile } from '../models/DocumentFile';
import { mapDocumentFileDtoToModel } from './mapDocumentFileDtoToModel';

export const transformDocumentFilesReply = (
  dto: DocumentFilesReply,
): Array<DocumentFile> => {
  return dto.files.map(mapDocumentFileDtoToModel);
};
